import React from 'react';
import styles from './index.module.scss';
import downloadBackground2 from '@/assets/download/download-bg-2.png';
import downloadPCEg from '@/assets/download/download-pc-eg.png';
import downloadSaucerman from '@/assets/download/download-saucerman.png';
import downloadMacLight from '@/assets/download/download-mac-light.png';
import downloadWindowsLight from '@/assets/download/download-windows-light.png';
import downloadMacDark from '@/assets/download/download-mac-dark.png';
import downloadWindowsDark from '@/assets/download/download-windows-dark.png';
import downloadClickTxt from '@/assets/download/download-click-txt.png';
import downloadHint from '@/assets/download/download-hint.png';
import downloadRecommendInstall from '@/assets/download/download-recommend-install.png';
import downloadTooltip from '@/assets/download/download-tooltip.png';

const DOWNLOAD_URL = {
  mac: 'https://cdn.yuaiweiwu.com/fe/aixue-clients/v1.0.3/aixue-1.0.3-mac-universal.dmg',
  windows32:
    'https://kannchwp.aiv5cdn.com/baichuan%2Fprod%2Fmarketing%2Fg3%2F0%2F2%2F32753637%2F32753702%2F37836557%2F37836575%2Faixue-1.0.3-windows-ia32.exe',
  windows64:
    'https://kannchwp.aiv5cdn.com/baichuan%2Fprod%2Fmarketing%2Fg3%2F0%2F2%2F32753637%2F32753702%2F37836557%2F37836576%2Faixue-1.0.3-windows-x64.exe',
};

function getWindowsDownloadUrl(): string {
  const ua = navigator.userAgent;
  const is64 = /Win64|x64|WOW64/i.test(ua);
  return is64 ? DOWNLOAD_URL.windows64 : DOWNLOAD_URL.windows32;
}

function handleDownload(type: 'mac' | 'windows') {
  const url = type === 'mac' ? DOWNLOAD_URL.mac : getWindowsDownloadUrl();
  window.location.href = url;
}

function getIsMac(): boolean {
  return /Mac|macOS|iPhone|iPad/i.test(navigator.userAgent);
}

function getIsWindows(): boolean {
  return /Windows|Win64|WOW64/i.test(navigator.userAgent);
}

export default function Screen2() {
  const isMac = getIsMac();
  const isWindows = getIsWindows();
  const macTooltip = !isMac && (isWindows ? '当前为 Windows 设备\n无法使用 Mac 版本' : '');
  const windowsTooltip = !isWindows && (isMac ? '当前为 Mac 设备\n无法使用 Windows 版本' : '');

  return (
    <section
      className={styles['download-section-2']}
      style={{ '--background-2-url': `url(${downloadBackground2})` } as React.CSSProperties}
    >
      <div className={styles['section2-wrap']}>
        <div className={styles['section2-eg-wrap']}>
          <img className={styles['section2-eg']} src={downloadPCEg} alt="download-pc-eg" />
          <img
            className={styles['section2-saucerman']}
            src={downloadSaucerman}
            alt="download-saucerman"
          />
        </div>
        <div className={styles['section2-content']}>
          <div className={styles['section2-titleBig']}>爱学PC客户端</div>
          <div className={styles['section2-desc']}>爱学客户端支持Mac、Windows下载</div>
          <img
            className={styles['section2-click-txt']}
            src={downloadClickTxt}
            alt="download-click-txt"
          />
          <div className={styles['section2-icon-row']}>
            <div className={styles['section2-icon-item']}>
              <span
                className={styles['section2-icon-box']}
                role="button"
                tabIndex={0}
                onClick={() => handleDownload('mac')}
                onKeyDown={(e) => e.key === 'Enter' && handleDownload('mac')}
              >
                {macTooltip && (
                  <span className={styles['section2-custom-tooltip']} aria-hidden>
                    <span
                      className={styles['section2-custom-tooltip-inner']}
                      style={{ backgroundImage: `url(${downloadTooltip})` }}
                    >
                      <span className={styles['section2-custom-tooltip-text']}>{macTooltip}</span>
                    </span>
                  </span>
                )}
                <span className={styles['section2-icon-inner']}>
                  <img
                    className={styles['section2-icon-light']}
                    src={downloadMacLight}
                    alt=""
                    aria-hidden
                  />
                  <img
                    className={styles['section2-icon-dark']}
                    src={downloadMacDark}
                    alt="Mac 下载"
                  />
                  {isMac && (
                    <img
                      className={styles['section2-icon-recommend']}
                      src={downloadRecommendInstall}
                      alt=""
                      aria-hidden
                    />
                  )}
                </span>
              </span>
              <div className={styles['section2-txt-item']}>版本大于等于12</div>
            </div>
            <div className={styles['section2-icon-item']}>
              <span
                className={styles['section2-icon-box']}
                role="button"
                tabIndex={0}
                onClick={() => handleDownload('windows')}
                onKeyDown={(e) => e.key === 'Enter' && handleDownload('windows')}
              >
                {windowsTooltip && (
                  <span className={styles['section2-custom-tooltip']} aria-hidden>
                    <span
                      className={styles['section2-custom-tooltip-inner']}
                      style={{ backgroundImage: `url(${downloadTooltip})` }}
                    >
                      <span className={styles['section2-custom-tooltip-text']}>
                        {windowsTooltip}
                      </span>
                    </span>
                  </span>
                )}
                <span className={styles['section2-icon-inner']}>
                  <img
                    className={styles['section2-icon-light']}
                    src={downloadWindowsLight}
                    alt=""
                    aria-hidden
                  />
                  <img
                    className={styles['section2-icon-dark']}
                    src={downloadWindowsDark}
                    alt="Windows 下载"
                  />
                  {isWindows && (
                    <img
                      className={styles['section2-icon-recommend']}
                      src={downloadRecommendInstall}
                      alt=""
                      aria-hidden
                    />
                  )}
                </span>
              </span>
              <div className={styles['section2-txt-item']}>版本大于等于10</div>
            </div>
          </div>

          <div className={styles['section2-icon-row']}>
            <img className={styles['section2-hint']} src={downloadHint} alt="download-hint" />
          </div>
        </div>
      </div>
    </section>
  );
}
